import StoryViewerRoute from '@/stories/StoryViewerRoute.vue';
import stories from '@/stories/index';
const route = {
    path: '/_stories',
    component: StoryViewerRoute,
    children: stories.map((story) => {
        return {
            path: story.path,
            component: story.component,
        };
    }),
};
export default route;
